import React, { FC } from 'react';

import { useOptionalUser } from '@adsk/alloy-provider';

import { useSetDynatraceUser } from '../../hooks/useSetDynatraceUser';
import { AnalyticsInitializer } from '../Analytics/AnalyticsInitializer';

export const OptionalUserListener: FC = () => {
  const { loading, data } = useOptionalUser();

  useSetDynatraceUser(data?.analyticsId);

  if (loading) {
    return null;
  }

  return <AnalyticsInitializer />;
};
